import { matchPath, useLocation } from "react-router-dom";

export const useAnyActivePath = (...urls) => {
  const { pathname } = useLocation();

  return urls.some((url) => matchPath(pathname, url));
};
